import callApi, { CallApiResult } from 'src/api';

export const fetchShippingCostTable = (): Promise<CallApiResult> => {
    const endpoint = '/api/shippingCostTable';
    return callApi(endpoint);
};
